import React from "react";
import BrandLogo from "./BrandLogo";
import "./AuthShell.css";

export default function AuthShell({ children, title, subtitle }) {
  return (
    <div className="auth-shell">
      <header className="auth-topbar">
        <BrandLogo to="/" className="auth-brand" height={44} />
      </header>

      <main className="auth-main">
        <div className="auth-card">
          {(title || subtitle) && (
            <div className="auth-card-head">
              {title ? <h1 className="auth-title">{title}</h1> : null}
              {subtitle ? <p className="auth-subtitle">{subtitle}</p> : null}
            </div>
          )}
          {children}
        </div>
      </main>
    </div>
  );
}
